/* Adtrip 14.08.2026 — poprawki UX zamowione przez klienta (Kuba/Saintby):
   dropdown menu otwarty hoverem zostaje przypiety (nie znika po zjechaniu kursorem).
   Zamykanie: klik poza menu, Esc, najechanie na inny element menu, klik w link. */
(function () {
  var PIN_MS = 2147000000;
  ['mega-menu-disclosure', 'dropdown-menu-disclosure'].forEach(function (tag) {
    customElements.whenDefined(tag).then(function () {
      var C = customElements.get(tag);
      if (!C) return;
      try {
        Object.defineProperty(C.prototype, 'mouseOverDelayTolerance', {
          get: function () { return PIN_MS; },
          configurable: true
        });
      } catch (e) { /* nie blokuj menu przy zmianie wewnetrznego API motywu */ }
    });
  });

  /* w trybie hover motyw nie zamyka menu klikiem poza nim — dodajemy to sami */
  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll(
      'mega-menu-disclosure details[open], dropdown-menu-disclosure details[open]'
    );
    open.forEach(function (d) {
      var host = d.closest('mega-menu-disclosure, dropdown-menu-disclosure');
      if (host && host.contains(e.target)) return;
      if (d.contains(e.target)) return;
      try {
        if (typeof d.toggle === 'function') { d.toggle(false); return; }
        if (host && typeof host.toggle === 'function') { host.toggle(false); return; }
      } catch (err) {}
      d.removeAttribute('open');
    });
  }, true);
})();
